export interface ProfessionalAttentionLogDetailDTO {
    professionalname: string | null;

    patientlat: number | null;
    patientlong: number | null;
    patientname: string | null;
    patientaddress: string | null;
    patienthealthcoveragedesc: string | null;
    patientbenefitnumber: string | null;

    nomenclators: ProfessionalAttentionLogNomenclatorDTO[] | null;
    totalhonorarium: number | null;

    arrivallat: number | null;
    arrivallong: number | null;
    arrivalhour: Date | null;
    statedarrivalhour: Date | null;
    locationarrivalvalidation: boolean | null;
    locationarrivaldescription: string | null;
    arrivaldatevalidated: boolean | null;

    leavelat: number | null;
    leavelong: number | null;
    leavehour: Date | null;
    statedleavehour: Date | null;
    locationleavevalidation: boolean | null;
    locationleavedescription: string | null;
    leavedatevalidated: boolean | null;

    minutesworked: string | null;
    statedminutesworked: string | null;
    hoursworked:number | null;

    professionalattentionlog: number | null;
    auditstate: number | null;
    auditedby: string | null;
    auditeddate: Date | null;
    observations: string | null;

    medicalEvolutions: MedicalEvolutionDTO[] | null;
}

export interface MedicalEvolutionDTO {
    // Fechas: Jackson las suele enviar como String ISO-8601
    recorddate: string | null;
    evolutiondate: string | null;

    // Números: BigDecimal y BigInteger se mapean a number
    scoretype: number | null;
    patientscore: number | null;
    
    // Strings básicos
    doctor: string;
    speciality: string;
    medicalevolution: string;
    queryspeciality: string;
    
    // Campos formateados (Strings)
    strrecorddate: string;
    strevolutiondate: string;
    strrscoretype: string;
    
    // IDs y Referencias Numéricas
    responseid: number | null;
    responsetoid: number | null;
    
    // Datos de padrón y profesional
    workerenrollment: string;
    enrollmenttype: string;
    
    // Firmas (Strings base64 o rutas)
    scannedsignature: string;
    signaturedata: string;
    
    // Observaciones
    observation: string;
    
    // Control numérico
    patientcontrol: number | null;
    professionalid: number | null;
    
    // Datos médicos adicionales
    hospitalizationlevel: string;
    evolutionquantity: number | null;


}

export interface ProfessionalAttentionLogNomenclatorDTO {
    professionalattentionlognomenclators?: number;
    nomenclator: number;
    nomenclatorcode: string;
    nomenclatordesc: string;
    honorarium: number;
    totalhonorarium:number;
    billedhours?: number;
    billingbyhour:boolean;
}

export const defaultProfessionalAttentionLogDetailDTO: ProfessionalAttentionLogDetailDTO = {
    professionalname: null,
    patientlat: null,
    patientlong: null,
    patientname: null,
    patientaddress: null,
    patienthealthcoveragedesc: null,
    patientbenefitnumber: null,

    nomenclators: null,
    totalhonorarium: null,

    arrivallat: null,
    arrivallong: null,
    arrivalhour: null,
    statedarrivalhour: null,
    locationarrivalvalidation: null,
    locationarrivaldescription: null,

    leavelat: null,
    leavelong: null,
    leavehour: null,
    statedleavehour: null,
    locationleavevalidation: null,
    locationleavedescription: null,
    minutesworked: null,
    statedminutesworked: null,
    arrivaldatevalidated: false,
    leavedatevalidated: false,
    hoursworked: 0,

    professionalattentionlog: null,
    auditstate: null,
    auditedby: null,
    auditeddate: null,
    observations: null,
    medicalEvolutions: []
};

export const defaultProfessionalAttentionLogNomenclatorDTO: ProfessionalAttentionLogNomenclatorDTO = {
    professionalattentionlognomenclators: 0,
    nomenclator: -1,
    nomenclatorcode: '',
    nomenclatordesc: '',
    honorarium: 0,
    totalhonorarium:0,
    billingbyhour:false
};